import {
  IQuestionnaireResponse,
  IQuestionnaireResponseAttachmentAnswerComponent,
  IQuestionnaireResponseBooleanAnswerComponent,
  IQuestionnaireResponseCodingAnswerComponent,
  IQuestionnaireResponseDateAnswerComponent,
  IQuestionnaireResponseDateTimeAnswerComponent,
  IQuestionnaireResponseDecimalAnswerComponent,
  IQuestionnaireResponseIntegerAnswerComponent,
  IQuestionnaireResponseItemAnswerComponent,
  IQuestionnaireResponseItemGroupComponent,
  IQuestionnaireResponseItemTableGroupComponent,
  IQuestionnaireResponseQuantityAnswerComponent,
  IQuestionnaireResponseReferenceAnswerComponent,
  IQuestionnaireResponseStringAnswerComponent,
  IQuestionnaireResponseTimeAnswerComponent,
  IQuestionnaireResponseUriAnswerComponent,
  QuestionnaireResponseAnswerComponent,
  QuestionnaireResponseItemComponent,
} from '.';
import { isTable } from '../Questionnaire/extensions';
//

export const isBooleanAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseBooleanAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseBooleanAnswerComponent).valueBoolean !==
      undefined
  );
};

export const isDecimalAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseDecimalAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseDecimalAnswerComponent).valueDecimal !==
      undefined
  );
};
export const isIntegerAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseIntegerAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseIntegerAnswerComponent).valueInteger !==
      undefined
  );
};
export const isDateAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseDateAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseDateAnswerComponent).valueDate !== undefined
  );
};
export const isDateTimeAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseDateTimeAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseDateTimeAnswerComponent).valueDateTime !==
      undefined
  );
};
export const isTimeAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseTimeAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseTimeAnswerComponent).valueTime !== undefined
  );
};
export const isStringAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseStringAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseStringAnswerComponent).valueString !==
      undefined
  );
};
export const isUriAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseUriAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseUriAnswerComponent).valueUri !== undefined
  );
};
export const isAttachmentAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseAttachmentAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseAttachmentAnswerComponent)
      .valueAttachment !== undefined
  );
};
export const isCodingAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseCodingAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseCodingAnswerComponent).valueCoding !==
      undefined
  );
};
export const isQuantityAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseQuantityAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseQuantityAnswerComponent).valueQuantity !==
      undefined
  );
};
export const isReferenceAnswerComponent = (
  item?: QuestionnaireResponseAnswerComponent,
): item is IQuestionnaireResponseReferenceAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseReferenceAnswerComponent).valueReference !==
      undefined
  );
};

export const isQuestionnaireResponseItemAnswer = (
  item?: QuestionnaireResponseItemComponent,
): item is IQuestionnaireResponseItemAnswerComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseItemAnswerComponent).answer !== undefined
  );
};

export const isQuestionnaireResponseItemGroup = (
  item?: QuestionnaireResponseItemComponent | null,
): item is IQuestionnaireResponseItemGroupComponent => {
  return (
    !!item &&
    (item as IQuestionnaireResponseItemGroupComponent).item !== undefined
  );
};

export const isQuestionnaireResponseItemTableGroup = (
  item?: QuestionnaireResponseItemComponent | null,
): item is IQuestionnaireResponseItemTableGroupComponent =>
  isQuestionnaireResponseItemGroup(item) && isTable(item);

export const isQuestionnaireResponse = (
  item?: any,
): item is IQuestionnaireResponse => {
  return (
    !!item &&
    (item as IQuestionnaireResponse).resourceType === 'QuestionnaireResponse'
  );
};
